import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { requestsSelectServiceTypes } from "../../../../reduxFolder/selectors/serviceRequestsSelectors";
import { getRequestInfoForType } from "../ServiceRequests/requestHelper";
import { CustomRasterIcon } from "../ServiceRequests/ServiceRequest.styles";
import { ServiceTooltip } from "./ServiceTooltip.styles";

interface ServiceTooltipItemProps {
  zIndex?: number;
  name: string;
  status: string;
  serviceRequestsTypes: any;
}

const ServiceTooltipItem: FC<ServiceTooltipItemProps> = React.memo(
  ({
    name,
    status,
    zIndex = 0,
    serviceRequestsTypes,
  }) => {
    const { t } = useTranslation("common");
    const isProcessed = status === "processed";

    const requestType = getRequestInfoForType(serviceRequestsTypes, name);
    const title = requestType?.get("title") || name;
    const body = `${title}: ${t(`serviceRequests.states.${status}`)}`;

    if (requestType && requestType.get("icon")) {
      return (
        <ServiceTooltip key={name} place="bottom" body={body} $zIndex={zIndex}>
          <CustomRasterIcon $iconUrl={requestType.get("icon")} $isProcessed={isProcessed} />
        </ServiceTooltip>
      );
    }

    return null;
  },
);

const withConnect = connect(
  createStructuredSelector({
    serviceRequestsTypes: requestsSelectServiceTypes,
  }),
);

export default withConnect(ServiceTooltipItem);
